<template>
  <component :is="component ? component : '<div/>'" :widget="widget" v-if="component"></component>
</template>

<script setup lang="ts">
import {computed, getCurrentInstance, PropType, shallowRef} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {capitalizeFirstLetter, snakeToCamel} from "~/lib/functions";
import {watch} from "#imports";
import Page from "../lib/models/Page";

const component = shallowRef(null);
const props = defineProps({
  page: Page,
  widget: Object as PropType<PageDataHolderFetchedWidget>
})


watch(() => props.widget, async () => {
  await loadWidgetItem();
})

const context = getCurrentInstance();

const loadWidgetItem = async () => {
  const matchFilename = props.widget.pageWidget.layout.match(/^.*[\\\/]Layout(\/Widget)?\/([A-Za-z]+)\/([a-z/_1-9A-Z]+)/) as String[];
  const filenameFolder = matchFilename[2] as String;
  const filename = (capitalizeFirstLetter(snakeToCamel(matchFilename[3].toLowerCase())).replace(filenameFolder, '')).replace(/\_/g, '');

  if (filename && context && typeof context.appContext.components["Widget" + filenameFolder + filename] === 'object') {
    // realComponent = resolveComponent("page/404");
    component.value = context.appContext.components["Widget" + filenameFolder + filename];
  } else {
    console.log(Object.keys(context.appContext.components));
    console.log("HolderWidget: Widget Layout not found: Widget" + filenameFolder + filename);

  }
}

await loadWidgetItem();
// console.log(Object.keys(context.appContext.components));
</script>
